import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AppAccessToken } from '../../shared-module/models/app-access-token';
import { AppResponseBase } from '../../shared-module/models/app-response-base';
import { LocalStorageService } from '../../shared-module/services/local-storage.service';
import { AccountService } from './account.service';
import { AuthService } from '../../shared-module/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  private apiUrl = `${environment.apiUrlBase}/api/userprofiles`;
  private authUrl = `${environment.authServerUrlBase}/api/user-profiles`;

  //private readonly _userProfile: BehaviorSubject<AppUserProfile> = new BehaviorSubject<AppUserProfile>(null);
  //readonly userProfile$ = this._userProfile.asObservable().pipe(map(profile => {
  //  if (!profile) {
  //    profile = this.userProfile;
  //  }
  //  return profile;
  //}));

  private userProfileKey = 'UserProfile';


  //set userProfile(profile: AppUserProfile) {
  //  this.localStorageService.setItem(this.userProfileKey, profile);
  //  this._userProfile.next(profile);
  //}

  //get userProfile() {
  //  let val = this._userProfile.getValue();
  //  if (!val) {
  //    val = this.localStorageService.getItem(this.userProfileKey);
  //  }
  //  return val;
  //}

  removeUserProfile() {
    //this.userProfile = null;
    this.localStorageService.removeItem(this.userProfileKey);
  }

  // createAppUserProfile(roles: string[]) {
  //   let userProfile = new AppUserProfile();

  //   roles.map(r => userProfile.profiles.push(r));

  //   if (roles.indexOf(UserRole.Admin) != -1) {
  //     userProfile.currentProfile = UserRole.Admin;
  //   }
  //   else if (roles.indexOf(UserRole.SecondaryAdmin) != -1) {
  //     userProfile.currentProfile = UserRole.SecondaryAdmin;
  //   }
  //   else if (roles.indexOf(UserRole.BranchManager) != -1) {
  //     userProfile.currentProfile = UserRole.BranchManager;
  //   }
  //   else if (roles.indexOf(UserRole.LoanOfficer) != -1) {
  //     userProfile.currentProfile = UserRole.LoanOfficer;
  //   }
  //   else if (roles.indexOf(UserRole.Loa) != -1) {
  //     userProfile.currentProfile = UserRole.Loa;
  //   }
  //   else if (roles.indexOf(UserRole.Processor) != -1) {
  //     userProfile.currentProfile = UserRole.Processor;
  //   }
  //   else if (roles.indexOf(UserRole.Funder) != -1) {
  //     userProfile.currentProfile = UserRole.Funder;
  //   }
  //   else if (roles.indexOf(UserRole.VirtualAssistant) != -1) {
  //     userProfile.currentProfile = 'Assistant';
  //   }
  //   else {
  //     userProfile.currentProfile = UserRole.Partner;
  //   }

  //   return userProfile;
  // }

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService,
    private accountService: AccountService,
    private authService: AuthService
  ) { }

  // old
  getTokenbyProfile(profile: string): Observable<AppAccessToken> {
    const url = `${this.apiUrl}/GetTokenByProfile?profile=${profile}`;
    return this.http.get<AppResponseBase<AppAccessToken>>(url).pipe(
      map(rs => {
        return rs.result!;
      })
    );
  }

  // new
  switchProfile(profile: string): Observable<AppAccessToken> {
    const url = `${this.authUrl}/switch/${profile}`;
    return this.http.post<AppResponseBase<AppAccessToken>>(url, null).pipe(
      map(rs => {
        console.log(rs)
        return rs.result!;
      })
    );
  }

  impersonateUser(userId: string): Observable<AppResponseBase<AppAccessToken>> {
    const url = `${this.authUrl}/${userId}/impersonate`;
    return this.http.post<AppResponseBase<AppAccessToken>>(url, null).pipe(
      map(rs => {
        return rs;
      },
        (err: any) => {
          console.error(err);
        })
    );
  }

  impersonateUserClerk(userId: string): Observable<{ token: string; returnToken: string }> {
    const url = `${this.apiUrl.replace('/userprofiles', '/impersonation')}/${userId}`;
    return this.http.post<AppResponseBase<{ token: string; returnToken: string }>>(url, null).pipe(
      map(rs => rs.result)
    );
  }
}
